import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ChevronLeftIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M15.707 18.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 1 1 1.414 1.414L10.414 12l5.293 5.293a1 1 0 0 1 0 1.414" />
    </Icon>
  );
}

ChevronLeftIcon.displayName = 'ChevronLeftIcon';
